import { render, staticRenderFns } from "./DealerMenu.vue?vue&type=template&id=00edd798&lang=pug&"
import script from "./DealerMenu.vue?vue&type=script&lang=js&"
export * from "./DealerMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports